import * as mapboxOutdoor from "./mapbox-outdoor";
import ownership from "./land-ownership";

export default {
  version: 8,
  name: "Custom",
  projection: { name: "globe" },
  sources: {
    "mapbox://mapbox.mapbox-terrain-dem-v1": {
      url: "mapbox://mapbox.mapbox-terrain-dem-v1",
      type: "raster-dem",
      tileSize: 512,
    },
    composite: {
      url: "mapbox://mapbox.mapbox-terrain-v2,mapbox.mapbox-bathymetry-v2,mapbox.mapbox-streets-v8",
      type: "vector",
    },
    "mapbox-satellite": {
      type: "raster",
      url: "mapbox://mapbox.satellite",
      tileSize: 256,
    },
    "land-ownership": {
      tiles: [`https://orienteer.co/tiles/{z}/{x}/{y}/ownership.mvt`],
      type: "vector",
      minzoom: 10,
      maxzoom: 13,
    },
    "scanned-topos": {
      type: "raster",
      tiles: [
        "https://services.arcgisonline.com/arcgis/rest/services/USA_Topo_Maps/MapServer/tile/{z}/{y}/{x}",
      ],
      tileSize: 256,
      maxzoom: 14,
    },
  },
  sprite: "mapbox://sprites/dstaudigel/cld7usqla001201nux2wr9hgg/draft",
  glyphs: "mapbox://fonts/dstaudigel/{fontstack}/{range}.pbf",
  layers: [
    {
      id: "background",
      type: "background",
      paint: {
        "background-color": "#ffffff",
      },
    },

    ...mapboxOutdoor.background,

    {
      id: "satellite",
      type: "raster",
      source: "mapbox-satellite",
      layout: {
        visibility: "none",
      },
    },

    {
      id: "scanned-topos",
      type: "raster",
      source: "scanned-topos",
      layout: {
        visibility: "none",
      },
    },

    ...mapboxOutdoor.features,
    ...ownership,
  ],
};
